/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Budget_InvalidInputs */

const en_ai_budget_invalid = /** @type {(inputs: Ai_Budget_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter an amount, e.g. 10,00.`)
};

const de_ai_budget_invalid = /** @type {(inputs: Ai_Budget_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib einen Betrag ein, z. B. 10,00.`)
};

/**
* | output |
* | --- |
* | "Enter an amount, e.g. 10,00." |
*
* @param {Ai_Budget_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ai_budget_invalid = /** @type {((inputs?: Ai_Budget_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Budget_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_ai_budget_invalid(inputs)
	return en_ai_budget_invalid(inputs)
});